<template>
    <div class="domestic">
        <headers :title="$t('国内业务')" img="domestic"></headers>
            <el-row :gutter="20">
                <el-col :span="3" :offset="5"><div class="btn InternationalBtn"> <router-link to="/domestic">{{$t('国内业务')}}</router-link></div></el-col>
                <el-col :span="3"><div class="btn domesticBtn"><router-link to="/International">{{$t('国际业务')}}</router-link> </div></el-col>
            </el-row>
            <div class="line"></div>
            <div class="title">{{$t('国内业务')}}</div>

            <el-row style="margin-top:2rem;margin-bottom:3rem;">
                <el-col :span="14" :offset="5"><div class="text">
                    {{$t('我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。')}}
                    </div>
                </el-col>
            </el-row>
            <Cooperation :data="iconList"></Cooperation>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
import Cooperation from "@/components/Cooperation.vue";
export default {
    data() {
        return {
            iconList:[
                'domestic1.jpg','domestic2.jpg','domestic3.jpg','domestic4.jpg','more.png'
            ]
        }
    },
    components:{
      headers,foot,Cooperation
    }
}
</script>
<style lang="less">
.domestic{
    .btn{
        line-height: 3rem;
        font-size: 0.8rem;
        cursor: pointer;
        white-space:nowrap;
    }
    .domesticBtn a{
        color: #A0A0A0;  
        text-decoration: none;      
    }
    .InternationalBtn a{
        color: #565656;
        text-decoration: none;
    }
    .line{
        height: 1px;
        width: 100%;
        background-color: #BFBFBF;
    }
    .title{
        font-size: 1.6rem;
        text-align: center;
        font-weight: bold;
        color: #747474;
        margin-top: 5rem;
        margin-bottom: 3rem;
    }
    .text{
        text-align: center;
        font-size: 0.75rem;
        color: #737373;
        line-height: 1.4rem;
        span{
            color: #017CA8;
        }
    }
}
</style>
<i18n>
{
  "en": {
    "国内业务":"Domestic Business",
    "国际业务":"International Business",
    "我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。":"Our customers are located in various provinces and cities across the country. At home, we mainly provide OEM production for several large domestic medical supplies production companies, such as Wenjian. Recognized in the industry with high quality. At the same time, it also provides a lot of general protective equipment for domestic animal husbandry."
  },
  "zh": {
    "国内业务":"国内业务",
    "国际业务":"国际业务",
    "我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。":"我们的客户遍布全国各省市， 在国内，主要为国内几家大型医疗用品生产公司进行代工生产，如稳健等。以优质的质量获得行业内的认可。同时也为国内畜牧业提供了大量的普通防护用品。"
    
  }
}
</i18n>

